import React from 'react';

const TrustIcons = () => (
  <div className="push-one-half--bottom payment-trust-image"
    style={{ height: 36, display: 'block', margin: '0 auto', width: '260px' }}
    />
);

export default TrustIcons;



// WEBPACK FOOTER //
// ./src/payments/views/finalize/TrustIcons.js